import { jbColors } from 'theme/jbColors';

const MuiDropzoneArea = {
  styleOverrides: {
    root: {
      maxHeight: '150px',
      minHeight: '100px',
      backgroundColor: '#E5F2F6',
      border: 'none',
      borderRadius: 0,
    },
    text: {
      fontFamily: 'Verlag, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      color: jbColors.support.greenSmoke[100],
      maxHeight: '5px',
    },
    textContainer: {
      maxHeight: '100px',
    },
  },
};

export default MuiDropzoneArea;
